export default __webpack_public_path__ + "static/media/EM0590.34I-21919_-15142_0.98dfed86.jpg";